import { render, staticRenderFns } from "./teaBackManager.vue?vue&type=template&id=3c1cbd7d"
import script from "./teaBackManager.vue?vue&type=script&lang=js"
export * from "./teaBackManager.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports